module.exports = __webpack_public_path__ + "img/headerImg-male.b2f4957a.png";